import React from 'react'
import { Typography,Collapse,Alert,Tooltip } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const { Panel } = Collapse;

/**
 * @param isCollapseDisabled disables collapse if any of custom field is required, without this user is able to close the collapse and form is submitted without filling the required field
 */
export default function CustomCollapse({props,defaultActiveKey,header,Key,description,type,content, alertProps={}, className, isCollapseDisabled=false}) {
    return (       
        <Collapse  {...props} className={classNames("pull-based-tool", props?.className || className)}
        defaultActiveKey={defaultActiveKey} bordered={false} expandIconPosition="right" expandIcon={({isActive}) => <Tooltip placement="topLeft" title={isCollapseDisabled ? "" : `Click to ${isActive ? "collapse" : "expand"}`}><CaretDownOutlined rotate={isActive ? 180 : 0} style={{ fontSize: 20 }} /></Tooltip>} collapsible={isCollapseDisabled ? "disabled" : undefined} showArrow={!isCollapseDisabled}>
        <Panel header={<Typography.Title className="m-b-0" level={5}>{header}</Typography.Title>} key={Key}>
            {
                content?(content):<Alert
                description={description}
                type={type}
                {...alertProps}
                />
            }
        </Panel>
    </Collapse>
    )
}
